/* Journeys — identity + surfaces, nothing else. The journey validator does
 * the heavy lifting; failed saves render its errors[] under the editor. */
import React, {
    useState
} from 'react';
import {
    useSearchParams
} from 'react-router-dom';
import CopyPackButton from '../../shared/CopyPackButton';
import DefEditorScreen from '../../shared/DefEditorScreen';
import DefWorkbench from '../../shared/DefWorkbench';
import NewDefButton from '../../shared/NewDefButton';
import JourneyFlowGraph from '../../shared/visuals/JourneyFlowGraph';

export default function JourneysPage() {
    const [listVersion, setListVersion] = useState(0);
    const [search, setSearch] = useSearchParams();
    // After a POST-create the engine returns the MINTED id — open the
    // editor on it straight away (selection lives in ?id=).
    const openCreated = (id: string) => {
        setListVersion((v) => v + 1);
        const next = new URLSearchParams(search);
        next.set('id', id);
        setSearch(next);
    };
    return (
        <DefWorkbench
            type="journey"
            title="Journeys"
            subtitle="The goal-units users enter — lists of surfaces"
            emptyHint="Every app is born with sign_in, sign_up and home. Add yours here."
            listVersion={listVersion}
            headActions={(
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }}>
                    <NewDefButton type="journey" onCreated={openCreated} />
                    <CopyPackButton stage="journeys" block />
                </div>
            )}
            renderDetail={(id) => (
                <DefEditorScreen
                    type="journey"
                    id={id}
                    onDeleted={() => setListVersion((v) => v + 1)}
                    visual={(text) => <JourneyFlowGraph docText={text} />}
                    actions={(text) => (
                        <CopyPackButton stage="journeys" currentDoc={{
                            label: `journey ${id}`,
                            text
                        }} />
                    )}
                />
            )}
        />
    );
}
